import Delivery from './delivery'
import Install from './install'

export default function(prefix, app) {
  return app
    .useRoute(`${prefix}/install`, Install)
    .useRoute(`${prefix}/delivery`, Delivery)
}
